import type { GlobalFacility, GlobalPowerRelationship, MapEvidenceSource } from '../types/global'

// Primary sources retrieved October 7, 2026. Region anchors are not surveyed parcels.
const construction: MapEvidenceSource = {
  title: 'Bell AI Fabric Sherwood construction update — October 1, 2026',
  publisher: 'Government of Saskatchewan',
  url: 'https://www.saskatchewan.ca/government/news-and-media/2026/october/01/bell-ai-fabric',
  checkedAt: '2026-10-07',
}
const conditionalExpansion: MapEvidenceSource = {
  title: 'Bell AI Fabric conditional Saskatchewan expansion — September 14, 2026',
  publisher: 'Bell Canada',
  url: 'https://explore.business.bell.ca/news-and-events/bell-ai-fabric-expansion-nation-building-project-adds-up-to-900-mw-additional-power',
  checkedAt: '2026-10-07',
}
const india: MapEvidenceSource = {
  title: 'CoreWeave announces AdaniConneX Taloja AI campus plans — October 6, 2026',
  publisher: 'CoreWeave',
  url: 'https://www.coreweave.com/news/coreweave-enters-india-expanding-ai-cloud-platform-with-adaniconnex',
  checkedAt: '2026-10-07',
}
const muhosRegulator: MapEvidenceSource = {
  title: 'Finnish authority requests suspension of significant preparatory works — October 6, 2026',
  publisher: 'Finnish Licensing and Supervision Authority / official STT Info release',
  url: 'https://api.sttinfo.fi/tiedote/72390663/lupa-ja-valvontavirasto-kehottaa-tuike-finland-oyta-keskeyttamaan-muhoksen-ja-kajaanin-datakeskushankkeiden-valmistelutoimet?publisherId=69821631',
  checkedAt: '2026-10-07',
}
const vaalaEia: MapEvidenceSource = {
  title: 'Vaala data center environmental assessment — updated October 2, 2026',
  publisher: 'Finnish environmental administration / Licensing and Supervision Authority',
  url: 'https://www.ymparisto.fi/fi/osallistu-ja-vaikuta/ymparistovaikutusten-arviointi/vaalan-datakeskus-vaala',
  checkedAt: '2026-10-07',
}

export const dailyGlobalFacilities: GlobalFacility[] = [{
  slug: 'bell-ai-fabric-sherwood',
  name: 'Bell AI Fabric Sherwood campus',
  countrySlug: 'canada',
  coordinates: [-104.62, 50.45],
  coordinatePrecision: 'Approximate Regina regional navigation anchor; the campus is in RM Sherwood, not this city-center point or a surveyed parcel',
  kind: 'Data center campus',
  status: 'Under construction',
  verification: 'under-construction',
  operatorSlugs: [],
  description: 'Saskatchewan confirms four first-phase buildings under construction in RM Sherwood, with the first data hall targeted for the first half of 2027. The initial 300 MW campus rating is future capacity, not operating load. A separate non-binding plan for up to 900 MW more would create a potential 1.2 GW Saskatchewan hub; customer commitments, permits and approvals remain conditions. No operating status or precise parcel is asserted.',
  sourceIds: [],
  evidence: 'sourced',
  evidenceSources: [construction, conditionalExpansion],
}, {
  slug: 'coreweave-adaniconnex-taloja', name: 'CoreWeave / AdaniConneX Taloja AI campus',
  countrySlug: 'india', coordinates: [73.0, 19.03],
  coordinatePrecision: 'Approximate Navi Mumbai regional navigation anchor; the named Taloja campus parcel is not geocoded',
  kind: 'Data center campus', status: 'In development', verification: 'announced',
  operatorSlugs: [],
  description: 'CoreWeave plans to be sole tenant of three 80 MW buildings at AdaniConneX’s Taloja campus in Navi Mumbai, totaling 240 MW of planned capacity. First-phase availability is expected in mid-2028; NVIDIA Vera Rubin deployment and subsequent phases remain future plans. An optional further 240 MW is not committed initial capacity. No commissioning, construction-start date or named electricity supplier is established.',
  sourceIds: [], evidence: 'company-reported', evidenceSources: [india],
}]

export const dailyGlobalFacilityUpdates: Record<string, { description: string; evidenceSources: MapEvidenceSource[] }> = {
  'google-muhos': {
    description: 'Google lists Muhos in development. On October 6, 2026 the Finnish authority requested that Tuike Finland suspend environmentally significant preparatory works immediately and no later than October 23 until its environmental impact assessment is complete. Planning, measurements and low-impact investigations are exempt. Actual implementation of the requested pause is unverified; this is not a cancellation or an operating campus.',
    evidenceSources: [muhosRegulator],
  },
  'google-vaala': {
    description: 'Google lists Vaala in development. The government environmental-assessment page updated October 2 describes four proposed buildings and a proposed 1.2–1.5 km 400 kV underground connection to Fingrid’s Nuojuankangas substation. The EIA is in progress; this is not a permit, an operating campus or dedicated generating-plant supply. Backup-generator fuel input is not campus IT or grid capacity. The Muhos/Kajaani preparatory-work notice does not name Vaala.',
    evidenceSources: [vaalaEia],
  },
}

export const dailyGlobalPowerRelationships: GlobalPowerRelationship[] = [{
  consumerSlug: 'bell-ai-fabric-sherwood',
  providerName: 'Saskatchewan provincial electricity grid',
  kind: 'Planned grid connection',
  status: 'Planned',
  description: 'The October 1 construction update says Dynamo Electric will build the high-voltage substation connecting the campus to the provincial grid. Dynamo is the substation contractor, not an identified electricity generator. The separate proposed expansion refers to partner-developed natural-gas generation without naming a plant or provider; no such plant location or exclusive power route is inferred.',
  evidenceSource: construction,
}, {
  consumerSlug: 'google-vaala', providerName: 'Fingrid Nuojuankangas substation / Finnish national grid',
  kind: 'Planned grid connection', status: 'Planned',
  description: 'The EIA proposes a 1.2–1.5 km 400 kV underground cable to Fingrid’s existing Nuojuankangas substation. Assessment is underway; approval and energization are not established. No generating plant, exclusive electricity source or substation coordinate is inferred.',
  evidenceSource: vaalaEia,
}]
